if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.klaviyoInitalLoad = false;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.hasKlaviyoBis = this.dataset.klaviyoBis !== undefined;
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      // Set-up event listener to listen for change event in <variant-radios>
      const variantRadios = document.getElementById(`VariantRadios-${this.dataset.sectionId}`)
      if(variantRadios) {
        variantRadios.addEventListener('variantChange', this.onVariantChange.bind(this))
      }

      if (this.submitButton.hasAttribute('disabled')) {
        this.observeKlaviyoBis();
      }
    }

    observeElement() {
      if (this.klaviyoBis() !== null && !this.klaviyoInitalLoad) {
        this.submitButton.classList.add('visually-hidden');
        this.klaviyoInitalLoad = true;
      }
    }

    observeKlaviyoBis() {
      new MutationObserver(() => {
        this.observeElement(this);
      }).observe(document.body, { childList: true, subtree: true });
    }

    klaviyoBis() {
      if(this.klaviyoBisButton === undefined || this.klaviyoBisButton === null) {
        this.klaviyoBisButton = document.querySelector('.klaviyo-bis-trigger');
      }
      return this.klaviyoBisButton;
    }

    onVariantChange(e) {
      // Add to Cart Enabled
      if(e.detail.available === true) {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.disabled = false;
        this.submitButton.querySelector('#cart-text-content').textContent = window?.variantStrings?.addToCart || 'Add to Cart';
        this.submitButton.classList.remove('visually-hidden');

        // If user lands on PDP with placeholder data, then selects valid variant, remove alert & set quantity input value
        const alertElement = document.querySelector('.placeholder-data-alert');
        if (alertElement) {
          location.reload();
        }
      // Add to Cart Disabled
      } else {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.disabled = true;
        this.submitButton.querySelector('#cart-text-content').textContent = window?.variantStrings?.soldOut || 'Sold Out';
        if(this.klaviyoBis() !== null) {
          this.submitButton.classList.add('visually-hidden');
        }
      }

      const shippingInfoContainer = document.getElementById('shipping-info');

      // Update the shipping info in the HTML
      if (shippingInfoContainer) {
        // Get an array of selected radio buttons
        const selectedRadios = document.querySelectorAll('input[type="radio"]:checked');

        if (selectedRadios.length > 0) {
          // Extract data-metafield-value values into an array
          const shippingInfoArray = Array.from(selectedRadios, radio => radio.dataset.metafieldValue);

          // Check if all values in the array are the same
          const areValuesSame = shippingInfoArray.every((value, index, array) => value === array[0]);

          // Update shippingInfoContainer.textContent based on the array
         areValuesSame
            ?  console.log(shippingInfoContainer.textContent)
            : 'Shipping info not available for this variant.';
        } else {
          shippingInfoContainer.classList.add('paragraph-xs');
          shippingInfoContainer.textContent = 'Shipping info not available for this variant.';
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay-spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay-spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
